module.exports = __webpack_public_path__ + "static/media/23.e5744d07.mp3";